export function handleInternalNavigation(event) {
  const anchor = event.currentTarget;
  const targetPath = anchor.getAttribute('href');

  if (!targetPath || targetPath.startsWith('http') || targetPath.startsWith('mailto:')) {
    return;
  }

  event.preventDefault();
  if (window.location.pathname === targetPath) {
    return;
  }

  window.history.pushState({}, '', targetPath);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
